import { render, staticRenderFns } from "./Oscar.vue?vue&type=template&id=62aee650&"
import script from "./Oscar.vue?vue&type=script&lang=js&"
export * from "./Oscar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports